import { ErrorHandler, inject } from '@angular/core';

import { mergeMap, pipe, switchMap } from 'rxjs';

import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { tapResponse } from '@ngrx/operators';
import { patchState, WritableStateSource } from '@ngrx/signals';

import { NAVIGATION_DATA_ADAPTER } from '../data-adapters/navigation-data-adapter.token';
import { NavigationProductItem } from '../models/navigation-product-item.type';
import { NavigationState } from './navigation.store';

export const navigationDataAdapterMethodsFactory = (
  store: WritableStateSource<NavigationState>,
  dataAdapter = inject(NAVIGATION_DATA_ADAPTER),
  errorHandler = inject(ErrorHandler),
) => ({
  loadProducts: rxMethod<boolean>(
    pipe(
      switchMap((mobile) =>
        dataAdapter.fetchProducts(mobile).pipe(
          tapResponse({
            next: (products) => patchState(store, { positionsMap: new Map(), products }),
            error: (error) => errorHandler.handleError(error),
          }),
        ),
      ),
    ),
  ),
  loadPositions: rxMethod<{ application: NavigationProductItem['application']; itemsUrl: string }>(
    pipe(
      mergeMap(({ application, itemsUrl }) =>
        dataAdapter.fetchPositions(itemsUrl).pipe(
          tapResponse({
            next: (positions) =>
              patchState(store, ({ positionsMap }) => ({
                positionsMap: new Map(positionsMap).set(application, positions),
              })),
            error: (error) => errorHandler.handleError(error),
          }),
        ),
      ),
    ),
  ),
});
